<template>
	<p-dialog
		:visible='value'
		@update:visible='onInput'
		modal
		dismissableMask

		:header='title'

		:contentStyle='contentStyle'

		@show='onShow'
	>
		<slot name='default'></slot>
	</p-dialog>
</template>

<script>
	export default {
		name: 'CustomPModal',

		props: {
			value: {
				type: Boolean,
				default: false
			},

			title: {
				type: String,
				default: ' '
			},

			contentStyle: {
				type: Object,
				default: () => ({})
			}
		},

		methods: {
			onInput(event) {
				this.$emit('input', event);
			},

			onShow(event) {
				this.$emit('show', event);
			}
		}

	};
</script>

<style scoped>
</style>